import { useEffect, useState } from "react";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const useFoundingDriverCount = () => {
  const [count, setCount] = useState(null);

  useEffect(() => {
    axios
      .get(`${API}/leads/count`)
      .then((res) => setCount(res.data?.count ?? 0))
      .catch(() => setCount(null));
  }, []);

  return count;
};
